<template lang="pug">
.extra-field
  app-entity(
    :replasable="false",
    :invert="invert",
    @close="$emit('close')",
    :relation="relation",
    :path="path === entity.name ? null : path",
    :entity="entity",
    v-bind="{ disabled, chips, parent }",
    :fromList="fromList",
    :selector="false",
  )
    template(v-slot:uISequence)
      v-text-field(
        :label="$t('ExtraField.uISequence')",
        type="number",
        :value="instance.uiSequence",
        @input="$store.commit(setInstancePathAction, { path: path + '.uiSequence', value: $event })"
      )
    template(v-slot:name)
      v-text-field(
        name="Name",
        :label="$t('ExtraField.name')",
        :value="name",
        @change="fixName",
      )
    template(v-slot:externalId)
      v-text-field(
        name="ExternalId",
        label="External ID",
        :value="instance.externalId",
        @input="$store.commit('SET_INSTANCE_PATH', { path: path + '.externalId', value: $event })")
    template(v-slot:type="slot")
      v-select(
        v-model="instance.type"
        :items="inputTypes"
        :label="$t('ExtraField.type')",
      )
    template(v-slot:addFields="slot")
      v-row.justify-start
        v-col(cols="3" v-if="!isBoolType(instance.type)")
          v-checkbox(
            name="required",
            v-model="required",
            :label="$t('ExtraField.required')",
          )
        v-col(cols="3", v-if="instance.type === 'String'")
          v-text-field(
            name="regex",
            v-model="regex",
            :label="$t('ExtraField.regex')",
          )
        v-col(cols="12", v-if="instance.type === 'String'")
          v-chip(@click:close="options.splice(i, 1)", :close="true", v-for="(option, i) in instance.options") {{option}}
          v-text-field(
            name="options",
            @keydown.enter="addOption",
            v-model="option",
            :label="$t('ExtraField.options')",
          )
</template>

<script>
import EntityMixin from '@/mixins'
export default {
  mixins: [EntityMixin],
  props: [
    'invert',
    'chips',
    'parentInstance',
    'parent',
    'entity',
    'relation',
    'path',
    'selector',
    'fromList'
  ],
  data: function () {
    return {
      loading: true,
      regex: '',
      name: '',
      rules: [],
      required: false,
      options: null,
      option: null,
      inputTypes:[
        {value: "String", text:"String"},
        {value: "Int", text:"Integer"},
        {value: "Bool", text:"Bool"},
        {value: "Double", text:"Decimal"},
        {value: "Date", text:"Date"},
        {value: "Datetime", text:"Datetime"}
      ]
    }
  },
  methods: {
    isBoolType(type) {
      if(type == 'Bool') {
        this.required = false;
        return true;
      }
      else {
        return false;
      }
    },
    fixName (name = '') {
      this.name = name.replace(/\s/g, '_')
    },
    addOption() {
      this.options = this.options || []
      this.options.push(this.option)
      this.option = null
      this.$store.commit('SET_INSTANCE_PATH', { path: this.path + '.options', value: this.options })
    },
    checkRules () {
      let regexRule = null
      let requiredRule = false
      for (let i = 0; i < this.instance.rules.length; i++) { // PARSE RULES OF EXTRAFIELDS to fill component required and regex field
        let regex_regex = /([a-zA-Z0-9]+\s*\=\>\s*)?[a-zA-Z0-9)]+\.EvaluateRegex\("(.*?)"\,.*/gm;
        let required_regex = /([a-zA-Z0-9]+\s*\=\>\s*[a-zA-Z0-9)]+\.)?GetExtraDataValue\("(.*?)"\)\s*\!\=\s*null/gm
        regexRule = regex_regex.exec(this.instance.rules[i].expression)
        if (regexRule != null) {
          this.regex = regexRule[2]
          continue
        }
        requiredRule = required_regex.exec(this.instance.rules[i].expression)
        if (requiredRule != null) {
          this.required = true
          continue
        }
      }
    }
  },
  computed: {
    groupName () {
      return this.$store.state.instance.name
    },
    //Add rules depending if the extrafield is required, or regex
    rule() {
      this.rules = []
      let instanceName = this.instance.name;
      let groupName = this.groupName;
      let regex = this.regex;
      //If it is required, add a rule to verify the value is not null
      if (this.required) {
        this.rules.push({
          name: groupName + '.' + instanceName,
          expression: 'x => x.GetExtraDataValue("' + groupName + '.' + instanceName + '") != null',
          errorMessage: 'ExtraDataRequired'
        })
      }
      //If the extrafield is regex, check if is required or not
      if (this.regex) {
        //If it is required, add a rule to evaluate the regex
        if (this.required){
          this.rules.push({
          name: groupName + '.' + instanceName,
          expression: 'x => x.EvaluateRegex("'+ regex +'", x.GetExtraDataValue("'+ groupName +'.'+ instanceName +'"))',
          errorMessage: 'ExtraDataRegex'
          })
        //If it is not required, add a rule where check if the value is null, returns approved rule
        //another rule to check if the value is not null, validate the regex
        } else {
          this.rules.push({
          name: groupName + '.' + instanceName,
          expression: 'x => x.GetExtraDataValue("' + groupName + '.' + instanceName + '") == null || x.GetExtraDataValue("' + groupName + '.' + instanceName + '") == "" || x.EvaluateRegex("' +regex + '", x.GetExtraDataValue("' + groupName + '.' + instanceName + '"))',
          errorMessage: 'ExtraDataRegex'
          })
        }
      }
      return this.rules
    }
  },
  watch: {
    name() {
      this.$store.commit('SET_INSTANCE_PATH', { path: this.path + '.path', value: `${this.groupName}.${this.name}` })
      this.$store.commit('SET_INSTANCE_PATH', { path: this.path + '.name', value: this.name })
      this.$store.commit('SET_INSTANCE_PATH', { path: this.path + '.rules', value: this.rule })
    },
    required(o, l) {
      // force rules evaluation
      this.$store.commit('SET_INSTANCE_PATH', { path: this.path + '.required', value: this.required })
      this.$store.commit('SET_INSTANCE_PATH', { path: this.path + '.rules', value: this.rule })
    },
    regex(o,l) {
      this.$store.commit('SET_INSTANCE_PATH', { path: this.path + '.rules', value: this.rule })
    },
    groupName() {
      this.$store.commit('SET_INSTANCE_PATH', { path: this.path + '.groupName', value: this.groupName })
      this.$store.commit('SET_INSTANCE_PATH', { path: this.path + '.rules', value: this.rule })
    },
    'instance.type'() {
       if(this.instance.type != 'String')
       {
          this.options = null;
          this.option = null;
          this.$store.commit('SET_INSTANCE_PATH', { path: this.path + '.options', value: this.options })
       }
         
    },
  },
  async mounted() {
    this.required = this.instance.required
    this.rules = this.instance.rules
    this.name = this.instance.name
    this.options = this.instance.options
    delete this.instance._options
    delete this.instance._Rules
    if (this.instance.rules){
      this.checkRules()
    }
  }
}
</script>
